import React from "react";

import State from "../../../../containers/State";
import { ReactComponent as StateIcon } from "../../../../img/icons/Guanacaste.svg";
import { CAMPAIGN_2020 } from '../../../../constants';

const stateName = "Guanacaste";
const stateId = "S6iSN3HKH3q7Bu5h4yVC";

const Guanacaste = () => {
  return (
    <State stateName={stateName} stateId={stateId} Icon={StateIcon} year="2020" campaign={CAMPAIGN_2020}>
      <StateIcon />
    </State>
  );
};

export default Guanacaste;
